import { useCallback } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { AiAssistantMainMenuTileItemConsentModal } from './AiAssistantMainMenuTileItemConsentModal';

type AiAssistantMainMenuTileItemConsentModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type AiAssistantMainMenuTileItemConsentModalOpenerProps = {
   children: (renderProps: AiAssistantMainMenuTileItemConsentModalOpenerRenderProps) => JSX.Element;
   onConfirm: VoidFunction;
};

export const AiAssistantMainMenuTileItemConsentModalOpener = (
   props: AiAssistantMainMenuTileItemConsentModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   const handleConfirm = useCallback(() => {
      closeModal();
      props.onConfirm();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeModal, props.onConfirm]);

   return (
      <>
         {props.children({ openModal: openModal })}

         {modalOpened ? (
            <AiAssistantMainMenuTileItemConsentModal onConfirm={handleConfirm} onClose={closeModal} />
         ) : null}
      </>
   );
};
